import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { PickCarPrintTable } from "./pickCarPrint";
import { ApprovalPrintTable } from "./approvalPrint";
import { CompletedPrintTable } from "./completedPrint";
import { useExternalBillModel } from "../externalBillModel";
import { DispatchDrawer } from "./DispatchDrawer";

export default () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, exportExternalBill,
        approvalPrintVisible, setApprovalPrintVisible,
        pickCarPrintVisible, setPickCarPrintVisible,
        completedPrintVisible, setCompletedPrintVisible } = useExternalBillModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <DispatchDrawer />
            <PickCarPrintTable pickCarPrintVisible={pickCarPrintVisible} setPickCarPrintVisible={setPickCarPrintVisible} />
            <ApprovalPrintTable approvalPrintVisible={approvalPrintVisible} setApprovalPrintVisible={setApprovalPrintVisible} />
            <CompletedPrintTable completedPrintVisible={completedPrintVisible} setCompletedPrintVisible={setCompletedPrintVisible} />
        </>
    )
}